import type { FC } from 'react';
import track from 'react-tracking';
import ReportSubSection from '@components/ReportSubSection';
import ReportNextSteps from '@components/ReportNextSteps';
import useDividendInvestingIdea from '@/components/Company/hooks/useDividendInvestingIdea';
import loadable from '@loadable/component';
import Fallback from '@/components/Fallback';

const NextSteps = loadable(
  () => import('@/components/CompanyOverview/components/NextSteps'),
  {
    ssr: false,
    fallback: <Fallback width="100%" height={104} />,
  }
);

export interface DividendNextStepsProps {
  countryISO: string;
  industryPrimaryName: string;
}

const DividendNextSteps: FC<DividendNextStepsProps & Tracking> = ({
  countryISO,
  industryPrimaryName,
}) => {
  const payload = useDividendInvestingIdea(countryISO.toLowerCase());
  return (
    <ReportSubSection
      title="Discover strong dividend paying companies"
      body={
        <ReportNextSteps>
          <li>
            {typeof payload !== 'undefined' && (
              <NextSteps
                link={payload.linkToInvestingIdea}
                industry={industryPrimaryName}
                section="dividend"
                market={countryISO}
              />
            )}
          </li>
        </ReportNextSteps>
      }
    />
  );
};

export default track(() => ({
  type: 'track',
  subject: 'DividendNextSteps',
}))(DividendNextSteps);
